//@ts-nocheck
import React from "react";
import parse from "html-react-parser";

export default function ParseHTML(props) {
  const { text } = props;
  return <React.Fragment>{text ? parse(text) : ""}</React.Fragment>;
}

export function Parse(text) {
  return text ? parse(text) : "";
}
